import { Text, Icon, Divider, Badge } from '@chakra-ui/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'react-map-gl';

import { IconLocationPin, IconBriefcase, IconFileClock, IconClock, IconBreakTime } from 'assets/icons';
import { formatMonthDayTime } from 'utils/format';

interface IStartLocationPopupProps {
  item: any;
  activeStartLocationPopup: any;
  setActiveStartLocationPopup: (value: any) => void;
}

const StartLocationPopup: React.FC<IStartLocationPopupProps> = ({
  activeStartLocationPopup,
  setActiveStartLocationPopup,
  item,
}) => {
  const { t } = useTranslation(['whoIsWorking', 'common']);

  return (
    <Popup
      latitude={activeStartLocationPopup?.latitude}
      longitude={activeStartLocationPopup?.longitude}
      closeButton={true}
      closeOnClick={false}
      onClose={() => setActiveStartLocationPopup(null)}
      anchor="top"
      className="mapbox-popup-wrapper"
    >
      <Text fontSize="md">
        {item?.first_name} {item?.last_name}
      </Text>
      {item?.clock_in_address ? (
        <>
          <Text color="gray.500" fontSize="xs">
            <Icon as={IconLocationPin} fontSize="xs" mr="1" />
            {item?.clock_in_address}
            <Divider borderStyle="dashed" my="3" />
          </Text>
        </>
      ) : null}
      {item?.job_name ? (
        <Text fontSize="xs" color="gray.500">
          <Icon as={IconBriefcase} fontSize="xs" mr="2" sx={{ '& path': { fill: 'gray.400' } }} />
          {item?.job_name}
        </Text>
      ) : null}
      {item?.task_name ? (
        <Text fontSize="xs" color="gray.500">
          <Icon as={IconFileClock} fontSize="xs" mr="2" />
          {item?.task_name}
        </Text>
      ) : null}
      {item?.current_break ? (
        <div>
          <Icon as={IconBreakTime} fontSize="xs" sx={{ '& path': { fill: 'gray.400' } }} mr="2" />
          <Badge px="2" textTransform="lowercase" borderRadius="base" colorScheme="primary" color="gray.500">
            {item?.current_break_name || 'Break'}
          </Badge>
        </div>
      ) : null}
      <Divider borderStyle="dashed" my="3" />
      <Text fontSize="xs" color="gray.500">
        <Icon as={IconClock} fontSize="xs" mr="2" />
        {t('common:clockedInOn')} {item?.clock_in_time ? formatMonthDayTime(item?.clock_in_time) : '- '}
      </Text>
    </Popup>
  );
};

export default memo(StartLocationPopup);
